import { OVERLAY_STATUS, CURRENT_USER, THEME_MODE } from "./actionTypes"

export function changeOverlayStatus(status) {
    return (
        {
            type: OVERLAY_STATUS,
            payload: status
        }
    )
}

export function changeCurrentUser(user) {
    return (
        {
            type: CURRENT_USER,
            payload: user
        }
    )
}

export function changeThemeMode(isDark) {
    return (
        {
            type: THEME_MODE,
            payload: isDark
        }
    )
}
